import { TableHeaderDataShape } from "./types";

/**
 * Given a { k:v } object, will generate an object for the `headerData` prop of a Carbon Table
 */
export const makeHeaderData = (headerToValueObject: object): TableHeaderDataShape[] => {
  const headers = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, header] of Object.entries(headerToValueObject)) {
    headers.push({
      header,
      key,
    });
  }

  return headers;
};
